<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ к Cube Banner</div>
    <div class="markup__h markup__h_3">
      Формат представляет из себя карусель из 4 слайдов (граней куба). Изображения пролистываются автоматически, или их можно пролистать вручную.
    </div>
    <br>
    <router-link to="/mobile/bannerCube" target="_blank" class="link">Демо формата</router-link>
    <br><br><br>
    <div class="markup__h markup__h_2">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <br>
    <div class="markup__h markup__h_3">
      <strong>Фоновые изображения для 4 слайдов:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Формат: PNG / JPG / PSD / FIGMA / AI</li>
      <li>Соотношение сторон: 1:1</li>
      <li>Размеры: ширина не менее 1000px </li>
    </ul>

    <div class="markup__h markup__h_3">
      <strong>Опционально:</strong>
    </div>
    <p>При отсутствии материалов по ТТ, описанном выше, для сборки креатива необходимо предоставить тексты и изображения, логотип, фирменные шрифты, Brandbook (в том числе пожелания по цветовому оформлению)</p>

    <marked-zone-atention></marked-zone-atention>
  </div>
</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'cubeBanner',
  components: {
    markedZoneAtention,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
